import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/PrivacyPolicy.css";
import InnerPageHeader from "./InnerPageHeader";
import HomepageButton from "./HomepageButton";
import Footer from "./Footer";

export default function PrivacyPolicy() {
  const { t } = useTranslation("privacy");
  const { t: tc } = useTranslation("common");

  const sections = t("sections", { returnObjects: true });

  return (
    <>
      <InnerPageHeader title={t("title")} subtitle={t("intro")} />

      <div className="policy-body">
        <div className="policy-content">
          {sections.map((section, idx) => (
            <div key={idx} className="policy-section">
              <h2>{section.heading}</h2>
              <p>{section.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="policy-back">
        <HomepageButton label={tc("back")} href="/#homepage" />
      </div>

      <Footer />
    </>
  );
}
